import type { AgentRole } from '../api/admin';

// 責務（役割）の表示ラベルと選択肢。エージェント／チームスロット／テンプレで共通利用する。
// 区分(type)横断の全役割。スロットやテンプレは type に縛られず役割だけを並べる。
export const ROLE_OPTIONS: { value: AgentRole; label: string }[] = [
  { value: 'pm_se', label: 'PM兼SE' },
  { value: 'implementer', label: '実装者' },
  { value: 'qa_tester', label: 'テスターQA' },
  { value: 'git_env_manager', label: 'GIT環境構築マネージャ' },
  { value: 'coo', label: 'COO' },
  { value: 'dev_lead', label: '開発責任者' },
  { value: 'finance_lead', label: '財務責任者' },
  { value: 'unset', label: '未設定' },
];

export const roleLabel = (r: AgentRole): string =>
  ROLE_OPTIONS.find((o) => o.value === r)?.label ?? r;
